import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import { register } from "../../../actions/auth";
import { setAlert } from "../../../actions/alert";
import PropTypes from "prop-types";
import DatePicker from "react-datepicker";

import Alert from "../IME/Alert";
import "react-datepicker/dist/react-datepicker.css";

const Register = ({
  users,
  register,
  getActiveUsers,
  isRegistered,
  setAlert,
  message,
}) => {
  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    username: "",
    dob: null,
    jobtitle: "",
    email: "",
    password: "",
    location: {
      country: "US",
      state: "Alabama",
      non_us_state: "",
      city: "",
    },
  });

  let passwordLength = formData.password.split("");

  const {
    firstname,
    lastname,
    username,
    dob,
    jobtitle,
    email,
    password,
    location,
  } = formData;

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(new Date());
  const [maxDate, setMaxDate] = useState(new Date());

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    if (firstname === "") {
      setAlert("Please enter your first name");
    }
    if (lastname === "") {
      setAlert("Please enter your last name");
    }
    if (username === "") {
      setAlert("Please enter a username");
    }
    if (jobtitle === "") {
      setAlert("Please enter your job title");
    }
    if (email === "") {
      setAlert("Please enter a valid email");
    }
    if (password === "") {
      setAlert("Please enter a password");
    }
    if (location === "") {
      setAlert("Please enter your location");
    }
    register({
      firstname,
      lastname,
      username,
      dob,
      jobtitle,
      email,
      password,
      location,
    });

    setFormData({
      firstname: "",
      lastname: "",
      username: "",
      dob: null,
      jobtitle: "",
      email: "",
      password: "",
      location: {
        country: "US",
        state: "Alabama",
        non_us_state: "",
        city: "",
      },
    });
  };

  useEffect(() => {
    getActiveUsers(username);
  }, [username]);

  let userNameLimit = username.split("").length;

  let emailLimit = email.split("").length;

  let firstNameLimit = firstname.split("").length;

  let lastNameLimit = lastname.split("").length;

  let jobTitleLimit = jobtitle.split("").length;

  let stateLimit = location.non_us_state.split("").length;

  let cityLimit = location.city.split("").length;

  const maxLengthUserName = 15;
  const maxLengthFirstName = 30;
  const maxLengthLastName = 30;
  const maxLengthEmail = 100;
  const maxLengthJobTitle = 50;
  const maxLengthState = 50;
  const maxLengthCity = 50;
  const maxLengthPassword = 20;

  if (isRegistered) {
    return <Redirect to="/setup" />;
  }

  return (
    <Fragment>
      <div className="sign-up-container">
        <div className="register-info">
          <div className="agreement-container">
            <div className="join-now-container">
              <p className="join-now green">
                The World's #1 Intellectwork - Join Now!
              </p>
            </div>
            <p className="motto">
              Life is better when we
              <br />
              innovate <span className="together green">TOGETHER.</span>
            </p>
            <p className="register-agreement">
              By clicking on the "Register" button below, you agree to ime's
              <Link to="/terms">
                <span className="agree green">Terms of Agreement</span>
              </Link>
              ,
              <Link to="/privacypolicy">
                <span className="agree green">Privacy Policy</span>
              </Link>
              and
              <Link to="/cookiepolicy">
                <span className="agree green">Cookie Policy</span>.
              </Link>
            </p>
          </div>
          <form
            action="/setup"
            method="POST"
            className="sign-up-form"
            onSubmit={(e) => onSubmit(e)}
          >
            <div className="items-container">
              <div className="sub-section-container-alt">
                <div className="flex-only">
                  <p className="sub-section green">User Info</p>
                </div>
                <div className="input-label-container">
                  <label htmlFor="username" className="labels-input green">
                    *Username: (min: 3 max: 15)
                  </label>
                  {username === "" && <Alert />}
                  {message !== "" ? message : ""}
                  {users.length > 0 && (
                    <p className="red bold mb-10">*Username already exists</p>
                  )}
                  {userNameLimit > 15 && (
                    <p className="red bold mb-10">*Username length too long</p>
                  )}
                  {userNameLimit < 3 && username !== "" && (
                    <p className="red bold mb-10">*Username length too short</p>
                  )}
                  <div className="edit-input-hidden">
                    <input
                      type="text"
                      name="username"
                      required
                      value={username}
                      maxLength={maxLengthUserName}
                      className={` ${
                        users && users.length > 0
                          ? "input-item-error red"
                          : "input-item"
                      }`}
                      placeholder="Create a Username"
                      onChange={(e) => onChange(e)}
                    />
                    <p className="white character-counter-comment">
                      {username.split("").length}/{maxLengthUserName} characters
                    </p>
                  </div>
                </div>
                <div className="input-label-container">
                  <label htmlFor="dob" className="labels-input green">
                    *Date of Birth:
                  </label>
                  {startDate === null && (
                    <p className="red bold">
                      *Please select your date of birth
                    </p>
                  )}
                  <div className="edit-input-hidden">
                    <DatePicker
                      className="sub-input-darker"
                      type="text"
                      name="dob"
                      value={dob}
                      selected={startDate}
                      maxDate={maxDate.setFullYear(endDate.getFullYear() - 13)}
                      onChange={(date) => {
                        setStartDate(date);
                        setFormData({
                          ...formData,
                          dob: date,
                        });
                      }}
                    />
                  </div>
                </div>
                <div className="input-label-container">
                  <label htmlFor="email" className="labels-input green">
                    *Email: (max: 100)
                  </label>
                  {emailLimit > 100 && (
                    <p className="red bold mb-10">
                      *Email name length too long
                    </p>
                  )}
                  {email === "" && <Alert />}
                  <div className="edit-input-hidden">
                    <input
                      type="email"
                      name="email"
                      maxLength={maxLengthEmail}
                      required
                      value={email}
                      className="input-item"
                      placeholder="Enter Email Address"
                      onChange={(e) => onChange(e)}
                    />
                    <p className="white character-counter-comment">
                      {email.split("").length}/{maxLengthEmail} characters
                    </p>
                  </div>
                </div>
                <div className="input-label-container">
                  <label htmlFor="firstname" className="labels-input green">
                    *First Name: (max: 30)
                  </label>
                  {firstNameLimit > 30 && (
                    <p className="red bold mb-10">
                      *First Name length too long
                    </p>
                  )}
                  {firstname === "" && <Alert />}
                  <div className="edit-input-hidden">
                    <input
                      type="text"
                      name="firstname"
                      maxLength={maxLengthFirstName}
                      required
                      value={firstname}
                      className="input-item"
                      placeholder="Enter First Name"
                      onChange={(e) => onChange(e)}
                    />
                    <p className="white character-counter-comment">
                      {firstname.split("").length}/{maxLengthFirstName}{" "}
                      characters
                    </p>
                  </div>
                </div>
                <div className="input-label-container">
                  <label htmlFor="lastname" className="labels-input green">
                    *Last Name: (max: 30)
                  </label>
                  {lastNameLimit > 30 && (
                    <p className="red bold mb-10">*Last Name length too long</p>
                  )}
                  {lastname === "" && <Alert />}
                  <div className="edit-input-hidden">
                    <input
                      type="text"
                      name="lastname"
                      maxLength={maxLengthLastName}
                      required
                      value={lastname}
                      className="input-item"
                      placeholder="Enter Last Name"
                      onChange={(e) => onChange(e)}
                    />
                    <p className="white character-counter-comment">
                      {lastname.split("").length}/{maxLengthLastName} characters
                    </p>
                  </div>
                </div>
                <div className="input-label-container">
                  <label htmlFor="jobtitle" className="labels-input green">
                    *Job Title: (max: 50)
                  </label>
                  {jobtitle === "" && <Alert />}
                  {jobTitleLimit > 50 && (
                    <p className="red bold mb-10">*Job title length too long</p>
                  )}
                  <div className="edit-input-hidden">
                    <input
                      type="text"
                      name="jobtitle"
                      maxLength={maxLengthJobTitle}
                      required
                      value={jobtitle}
                      className="input-item"
                      placeholder="Enter Job Title"
                      onChange={(e) => onChange(e)}
                    />
                    <p className="white character-counter-comment">
                      {jobtitle.split("").length}/{maxLengthJobTitle} characters
                    </p>
                  </div>
                </div>
                <div className="sub-grid-three-alt-subscribe">
                  <div className="input-grid">
                    <label htmlFor="country" className="green bold block">
                      *Country
                    </label>
                    {formData.location.country === "" && <Alert />}
                    <select
                      name="country"
                      id="country"
                      type="country"
                      required
                      value={formData.location.country}
                      onChange={(e) => {
                        const locationDetails = { ...formData };
                        locationDetails.location.country = e.target.value;
                        setFormData(locationDetails);
                      }}
                    >
                      <option value="US">US</option>
                      <option value="AU">AU</option>
                      <option value="AT">AT</option>
                      <option value="BE">BE</option>
                      <option value="BR">BR</option>
                      <option value="BG">BG</option>
                      <option value="CA">CA</option>
                      <option value="CY">CY</option>
                      <option value="CZ">CZ</option>
                      <option value="DK">DK</option>
                      <option value="EE">EE</option>
                      <option value="FI">FI</option>
                      <option value="FR">FR</option>
                      <option value="DE">DE</option>
                      <option value="GR">GR</option>
                      <option value="HK">HK</option>
                      <option value="HU">HU</option>
                      <option value="IN">IN</option>
                      <option value="IE">IE</option>
                      <option value="IT">IT</option>
                      <option value="JP">JP</option>
                      <option value="LV">LV</option>
                      <option value="LT">LT</option>
                      <option value="LU">LU</option>
                      <option value="MY">MY</option>
                      <option value="MT">MT</option>
                      <option value="MX">MX</option>
                      <option value="NL">NL</option>
                      <option value="NZ">NZ</option>
                      <option value="NO">NO</option>
                      <option value="PL">PL</option>
                      <option value="PT">PT</option>
                      <option value="RO">RO</option>
                      <option value="SG">SG</option>
                      <option value="SK">SK</option>
                      <option value="SI">SI</option>
                      <option value="ES">ES</option>
                      <option value="SE">SE</option>
                      <option value="CH">CH</option>
                      <option value="AE">AE</option>
                      <option value="GB">GB</option>
                    </select>
                  </div>
                  {formData.location.country === "US" && (
                    <div className="input-grid">
                      <label htmlFor="state" className="green bold block">
                        *State:
                      </label>
                      {formData.location.state === "" && <Alert />}
                      <select
                        name="state"
                        id="state"
                        type="state"
                        required
                        value={formData.location.state}
                        onChange={(e) => {
                          const locationDetails = { ...formData };
                          locationDetails.location.state = e.target.value;
                          setFormData(locationDetails);
                        }}
                      >
                        <option value="AL">Alabama</option>
                        <option value="AK">Alaska</option>
                        <option value="AZ">Arizona</option>
                        <option value="AR">Arkansas</option>
                        <option value="CA">California</option>
                        <option value="CZ">Canal Zone</option>
                        <option value="CO">Colorado</option>
                        <option value="CT">Connecticut</option>
                        <option value="DE">Delaware</option>
                        <option value="DC">District of Columbia</option>
                        <option value="FL">Florida</option>
                        <option value="GA">Georgia</option>
                        <option value="GU">Guam</option>
                        <option value="HI">Hawaii</option>
                        <option value="ID">Idaho</option>
                        <option value="IL">Illinois</option>
                        <option value="IN">Indiana</option>
                        <option value="IA">Iowa</option>
                        <option value="KS">Kansas</option>
                        <option value="KY">Kentucky</option>
                        <option value="LA">Louisiana</option>
                        <option value="ME">Maine</option>
                        <option value="MD">Maryland</option>
                        <option value="MA">Massachusetts</option>
                        <option value="MI">Michigan</option>
                        <option value="MN">Minnesota</option>
                        <option value="MS">Mississippi</option>
                        <option value="MO">Missouri</option>
                        <option value="MT">Montana</option>
                        <option value="NE">Nebraska</option>
                        <option value="NV">Nevada</option>
                        <option value="NH">New Hampshire</option>
                        <option value="NJ">New Jersey</option>
                        <option value="NM">New Mexico</option>
                        <option value="NY">New York</option>
                        <option value="NC">North Carolina</option>
                        <option value="ND">North Dakota</option>
                        <option value="OH">Ohio</option>
                        <option value="OK">Oklahoma</option>
                        <option value="OR">Oregon</option>
                        <option value="PA">Pennsylvania</option>
                        <option value="PR">Puerto Rico</option>
                        <option value="RI">Rhode Island</option>
                        <option value="SC">South Carolina</option>
                        <option value="SD">South Dakota</option>
                        <option value="TN">Tennessee</option>
                        <option value="TX">Texas</option>
                        <option value="UT">Utah</option>
                        <option value="VT">Vermont</option>
                        <option value="VI">Virgin Islands</option>
                        <option value="VA">Virginia</option>
                        <option value="WA">Washington</option>
                        <option value="WV">West Virginia</option>
                        <option value="WI">Wisconsin</option>
                        <option value="WY">Wyoming</option>
                      </select>
                    </div>
                  )}
                  {formData.location.country !== "US" && (
                    <div className="input-grid">
                      <label
                        htmlFor="non_us_state"
                        className="green bold block"
                      >
                        *State: (max: 50)
                      </label>
                      {formData.location.non_us_state === "" && <Alert />}
                      {stateLimit > 50 && (
                        <p className="red bold mb-10">*State name too long</p>
                      )}
                      <div className="edit-input-hidden">
                        <input
                          className="sub-input-dark"
                          name="non_us_state"
                          maxLength={maxLengthState}
                          id="non_us_state"
                          type="text"
                          placeholder="Enter State"
                          required
                          value={formData.location.non_us_state}
                          onChange={(e) => {
                            const Location = { ...formData };
                            Location.location.non_us_state = e.target.value;
                            setFormData(Location);
                          }}
                        />
                        <p className="white character-counter-comment">
                          {formData.location.non_us_state.split("").length}/
                          {maxLengthState} characters
                        </p>
                      </div>
                    </div>
                  )}
                  <div className="input-grid-alt">
                    <label htmlFor="city" className="green bold block">
                      *City: (max: 50)
                    </label>
                    {cityLimit > 50 && (
                      <p className="red bold mb-10">*City name too long</p>
                    )}
                    {formData.location.city === "" && <Alert />}
                    <div className="edit-input-hidden">
                      <input
                        className="input-item"
                        name="city"
                        id="city"
                        type="text"
                        maxLength={maxLengthCity}
                        placeholder="Enter City"
                        required
                        value={formData.location.city}
                        onChange={(e) => {
                          const locationDetails = { ...formData };
                          locationDetails.location.city = e.target.value;
                          setFormData(locationDetails);
                        }}
                      />
                      <p className="white character-counter-comment">
                        {formData.location.city.split("").length}/
                        {maxLengthCity} characters
                      </p>
                    </div>
                  </div>
                </div>
                <div className="input-label-container">
                  <label htmlFor="password" className="labels-input green">
                    *Password: (min: 7 max: 20):
                  </label>
                  {password === "" && <Alert />}
                  {passwordLength.length < 7 && password !== "" && (
                    <p className="red bold mb-10">*Password length too short</p>
                  )}
                  {passwordLength.length > 20 && (
                    <p className="red bold mb-10">*Password length too long</p>
                  )}
                  <div className="edit-input-hidden">
                    <input
                      type="password"
                      name="password"
                      minLength={7}
                      maxLength={maxLengthPassword}
                      required
                      value={password}
                      className="input-item"
                      placeholder="Enter Password"
                      onChange={(e) => onChange(e)}
                    />
                    <p className="white character-counter-comment">
                      {password.split("").length}/{maxLengthPassword} characters
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {firstname !== "" &&
              lastname !== "" &&
              username !== "" &&
              jobtitle !== "" &&
              email !== "" &&
              password !== "" &&
              location.country !== "" &&
              location.state !== "" &&
              location.city !== "" &&
              startDate !== null &&
              users.length <= 0 &&
              passwordLength.length >= 7 &&
              passwordLength.length <= 20 &&
              userNameLimit >= 3 &&
              userNameLimit <= 15 &&
              firstNameLimit > 0 &&
              firstNameLimit <= 30 &&
              lastNameLimit > 0 &&
              lastNameLimit <= 30 &&
              jobTitleLimit > 0 &&
              jobTitleLimit <= 50 &&
              cityLimit > 0 &&
              cityLimit <= 30 &&
              emailLimit < 100 && (
                <div className="submit-changes-register">
                  <button
                    className="submit-changes-button background-green"
                    onSubmit={(e) => onSubmit(e)}
                  >
                    Register
                  </button>
                </div>
              )}
          </form>
        </div>
      </div>
    </Fragment>
  );
};

Register.propTypes = {
  register: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  isRegistered: state.auth.isRegistered,
});

export default connect(mapStateToProps, { register, setAlert })(Register);
